import Vue from 'vue'
import Vuex from 'vuex'
import BackendService from '../services/requests/backendService'
import FrontendConfigService from '../services/configs/frontendConfigService'
Vue.use(Vuex)

const formularioStore = new Vuex.Store({
	state: {
		loading: false,

		turmas: [],
		loadingTurmas:false,

		cursos: [],
		loadingCursos:false,

		disciplinas: [],
		loadingDisciplinas:false,

		salas: [],
		loadingSalas:false,

		finalidades: [],
		loadingFinalidades:false,

		notifications: []
	},
	mutations: {
		setLoading(state, value) { state.loading = value },

		setCursos(state, value) { state.cursos = value },
		setLoadingCursos(state, value) { state.loadingCursos = value },

		setDisciplinas(state, value) { state.disciplinas = value },
		setLoadingDisciplinas(state, value) { state.loadingDisciplinas = value },

		setSalas(state, value) { state.salas = value },
		setLoadingSalas(state, value) { state.loadingSalas = value },

		setFinalidades(state, value) { state.finalidades = value },
		setLoadingFinalidades(state, value) { state.loadingFinalidades = value },

		setTurmas(state, value) { state.turmas = value },
		setLoadingTurmas(state, value) { state.loadingTurmas = value },

		setNotifications(state, value){ 
			state.notifications = value 
		}
	},
	getters:{
		getTurmas(state){
			const turmas = state.turmas.map(obj=>{
				return obj.CODTURMA
			})
			return turmas
		},
		getCursos(state){
			const cursos = state.cursos.map(obj=>{
				return obj.CURSO
			})
			return cursos
		},
		getDisciplinas(state){
			const disciplinas = state.disciplinas.map(obj=>{
				return obj.DISCIPLINA
			})
			return disciplinas
		},
		getNotifications(state){
			return state.notifications
		},
		isLoading(state){
			return state.loading || state.loadingCursos || state.loadingDisciplinas ||
			state.loadingFinalidades || state.loadingSalas || state.loadingTurmas
		},
		isLoadingRequests(state){
			return state.loadingCursos || state.loadingDisciplinas ||
			state.loadingFinalidades || state.loadingSalas || state.loadingTurmas
		}
	},
	actions: {
		tryError: async(context, error)=>{
			let err = FrontendConfigService.tryNotificationErrors(error)
			context.commit('setNotifications', [{'tag':err.tag, 'message': err.message}])
		},
		request_salas: async (context)=>{
			const req = new BackendService()
			context.commit('setLoadingSalas', true)
			return await req.get_salas()
				.then( response => { 
					context.commit('setSalas', response.data); 
				}).catch( error => { 
					console.error(error); 
					context.commit('setSalas', []) 
					context.dispatch('tryError', error) 
				}).finally( () => { 
					context.commit('setLoadingSalas', false) 
				})
		},
		request_finalidades: async (context)=>{
			const req = new BackendService()
			context.commit('setLoadingFinalidades', true)
			return await req.get_finalidades()
				.then( response => { 
					context.commit('setFinalidades', response.data); 
				}).catch( error => { 
					console.error(error.response); 
					context.commit('setFinalidades', []) 
					context.dispatch('tryError', error) 
				}).finally( () => { 
					context.commit('setLoadingFinalidades', false) 
				})
		},
		request_cursos: async (context)=>{
			const req = new BackendService()
			context.commit('setLoadingCursos', true)
			return await req.get_cursos()
				.then( response => { 
					context.commit('setCursos', response.data); 
				}).catch( error => { 
					console.error(error); 
					context.commit('setCursos', []) 
				}).finally( () => { 
					context.commit('setLoadingCursos', false) 
				})
		},
		request_disciplinas: async (context)=>{
			const req = new BackendService()
			context.commit('setLoadingDisciplinas', true)
			return await req.get_disciplinas()
				.then( response => { 
					context.commit('setDisciplinas', response.data); 
				}).catch( error => { 
					console.error(error); 
					context.commit('setDisciplinas', []) 
				}).finally( () => { 
					context.commit('setLoadingDisciplinas', false) 
				})
		},
		request_turmas: async (context)=>{
			const req = new BackendService()
			context.commit('setLoadingTurmas', true)
			return await req.get_turmas()
				.then( response => { 
					context.commit('setTurmas', response.data)
				}).catch( error => { 
					console.error(error.response); 
					context.commit('setTurmas', [])
				}).finally( () => { 
					context.commit('setLoadingTurmas', false) 
				})
		},
		create_agenda: async (context, {agenda, headers})=>{
			const req = new BackendService()
			// .then e .catch utilizados diretamente no componente para controle successo ou erro
			headers // removendo header por compatibilidade com iOs
			return await req.post_agendamento(agenda)
			
		},
	}
})

export default formularioStore
